<template>
	<Overlay data-for="translation-language-button" placement="below" @close="$emit('close')">
		<div class="translation-language-container" @click.stop>
			<div class="translation-language-header">
				<h3>{{ t('tutorialPage.translationLanguage.title') }}</h3>
			</div>
			<SearchableLanguageList
				:languages="translateLanguages"
				:selected-locale="targetLang"
				:search-placeholder="
					t('Pages.SelectLanguage.SearchPlaceholder')
				"
				:empty-text="t('Pages.SelectLanguage.SearchEmpty')"
				@select="handleOptionOnClick"
			/>
		</div>
	</Overlay>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'
import { Overlay } from '@shared-components'
import { findLanguageItemsBySupportAzureSTT } from '@shared-data'
import { useInfoStore } from '@shared-store'
import { useI18n } from 'vue-i18n'
import SearchableLanguageList from '../common/SearchableLanguageList.vue'

export default defineComponent({
	name: 'TranslationLanguageOverlay',
	components: { Overlay, SearchableLanguageList },
	emits: ['change', 'close'],
	setup(_, { emit }) {
		// 使用資訊存儲
		const { setTargetLang, targetLang, supportedTranslationLanguages } =
			useInfoStore()
		// 使用 i18n
		const { t } = useI18n()

		// 該會議支持的翻譯語言列表
		const translateLanguages = computed(() =>
			findLanguageItemsBySupportAzureSTT(supportedTranslationLanguages),
		)

		/**
		 * 處理語言選項點擊事件
		 * @param lang {string} 選擇的語言
		 * @return {void}
		 */
		const handleOptionOnClick = (lang: string): void => {
			// 將選擇的語言值存入本地存儲
			setTargetLang(lang)
			// 發出change事件，傳遞選擇的語言
			emit('change', lang)
			// 關閉overlay
			emit('close')
		}

		return {
			t,
			targetLang,
			translateLanguages,
			handleOptionOnClick,
		}
	},
})
</script>
<style lang="scss">
// 標題字體粗細
$header-font-weight: 600;
// 標題文字大小
$option-font-size: 16px;
// 標題文字顏色
$option-text-color: rgba(0, 0, 0, 0.87);
// 面板寬度
$translation-language-width: 320px;

.translation-language-container {
	width: $translation-language-width;
	max-width: 90vw;
	padding: 0 12px 12px;
	box-sizing: border-box;

	.translation-language-header {
		text-align: center;
		margin-bottom: 0;
		padding: 12px 6px;
		border-bottom: 1px solid #e0e0e0;

		h3 {
			margin: 0;
			font-size: $option-font-size;
			font-weight: $header-font-weight;
			color: $option-text-color;
		}
	}

	// SearchableLanguageList 元件根節點，Overlay 本身是貼著按鈕定位的浮層，改用 CSS 變數把高度上限收窄，不用頁面等級的 70vh
	.searchable-language-list {
		padding-top: 12px;
		--searchable-language-list-max-height: 50dvh;
	}
}
</style>
